jQuery(document).ready(function($){
    $('[href^="https://vimeo.com/"]:not(.list-social__link)').each(function(){
      if (! $(this).hasClass("unbutton")) {
        $(this).addClass("btn-watch").html("<i class='fa fa-play'> </i> watch");
      }
      $(this).fancybox({'width':800, 'height':450, 'autoSize' : false});
  });
  faq_list($);
});

function faq_list ($) {
  var max_q = 200;
	var sliding = false;
	var click_q = function () {
		if (sliding) return;
		sliding = true;
		this.classList.toggle('closed');
		$(this.nextElementSibling).slideToggle(300, function () {
			sliding = false;
		});
	};

	$('.faq-list').each(function () {
      
		var $faq_list = $(this);
		var $faqs = $faq_list.find('.faqdata');
		var faq_count = $faqs.length;
		var $more_faqs = $faq_list.find('.more-faqs');
		var showall = this.hasAttribute('showall');
		$faqs.each(function (index, element) {
			$(element).find('> .question').click(click_q).find('> .hd').attr('q-num', index + 1);

			if (index >= max_q && faq_count > max_q + 1 && !showall) {
				this.classList.add('hide');
			}
		});
		if (faq_count > max_q + 1 && !showall) {
			$more_faqs.removeClass('hide');
			$more_faqs.find('.more-faqs-btn').click(function () {
				$faqs.removeClass('hide');
				$more_faqs.remove();
			});
		} else {
			$more_faqs.remove();
		}
	});
    
}